import React, {FC, useEffect, useState} from 'react'
import {Button} from 'shared/ui/buttons'

type TimerButtonProps = {
  onClick: (timerStart: Function) => void
}

export const TimerButton: FC<TimerButtonProps> = ({onClick}) => {
  const [isDisabled, setIsDisabled] = useState(false)
  const [timer, setTimer] = useState(0)
  let interval: number

  const timerHandler = () => {
    setIsDisabled(true)
    setTimer(60)
    interval = window.setInterval(() => setTimer(state => {
      if (state - 1 === 0) {
        clearInterval(interval)
        setIsDisabled(false)
      }

      return state - 1
    }), 1000)
  }

  const onClickHandler = () => {
    onClick(timerHandler)
  }

  useEffect(() => {
    return () => clearInterval(interval)
  }, [])

  return (
    <Button
      type='button'
      isLoading={isDisabled}
      isDisabled={isDisabled}
      fullwidth
      styleType='outlinedGray'
      onClick={onClickHandler}
    >
      Resend {timer ? timer + 's' : ''}
    </Button>
  )
}